import { clsx as t } from "../node_modules/clsx/dist/clsx.es.js";
import { extendTailwindMerge as e } from "../node_modules/tailwind-merge/dist/bundle-mjs.es.js";
const o = () => {
}, n = e({
  prefix: "rcl--"
}), i = (...r) => n(t(r)), a = {
  onError: o,
  onLoad: o
};
export {
  a as OnLoadOnErrorDefaults,
  i as classes,
  o as identity
};
//# sourceMappingURL=component.es.js.map
